import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Container, Table } from "reactstrap"
import reportIMG from "../../assets/images/report1.png"
import noreportIMG from "../../assets/images/noReport.jpg"
import { fetchData } from "utils/Common_api_functions"
import moment from "moment"
import { formatAnyTime } from "utils/commonFunctions"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"

const Reports = () => {
  const [loading, setLoading] = useState(false)
  const [selectedDate, setSelectedDate] = useState("")
  const [selectedLocation, setSelectedLocation] = useState("")

  const [allData, setAllData] = useState([])
  const [events, setEvents] = useState([])
  const [timeSheets, settimesheets] = useState([])

  const uniqueLocations = [
    ...new Map(
      allData.map(e => [
        e.locationId,
        { id: e.locationId, name: e.location?.name },
      ])
    ).values(),
  ]

  useEffect(() => {
    if (selectedDate) {
      getEvents()
    }
  }, [selectedDate])

  async function getEvents() {
    const APIdata = await fetchData(
      setLoading,
      `dashboard/counts?date=${moment(selectedDate)?.format("YYYY-MM-DD")}`
    )
    if (APIdata?.success) {
      setAllData(APIdata?.events)
      setEvents(APIdata?.events)
      settimesheets(APIdata?.timesheets)
    } else {
      setAllData([])
      setEvents([])
      settimesheets([])
    }
  }

  useEffect(() => {
    if (selectedLocation) {
      const FilteredData = allData?.filter(
        item => item?.locationId === Number(selectedLocation)
      )
      console.log(selectedLocation, FilteredData)
      setEvents(FilteredData)
    } else {
      setEvents(allData)
    }
  }, [selectedLocation])

  const { checkAccess } = usePermissionData()

  return (
    <div className="page-content">
      <PermittedComponent isAccess={checkAccess(8, 1) || checkAccess(8, 2)}>
        {loading && <Loader />}
        <Container fluid>
          <Breadcrumb
            title={"Reports"}
            breadcrumbItem={"Daily Report"}
            description={"View and Check Reports of Individual Day"}
          />

          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-5">
                <h4>Daily Reports</h4>
                <div className="d-flex gap-3">
                  <div className="d-block">
                    <h6>Select Date</h6>
                    <input
                      className="form-control"
                      type="date"
                      value={selectedDate}
                      onChange={e => setSelectedDate(e.target.value)}
                      style={{ width: "160px" }}
                    ></input>
                  </div>
                  <div>
                    <h6>Select Lcoation</h6>
                    <select
                      className="form-select w-auto rounded-4 py-2 pe-5"
                      value={selectedLocation}
                      onChange={e => setSelectedLocation(e.target.value)}
                    >
                      <option value="">All Locations</option>
                      {uniqueLocations.map(emp => (
                        <option key={emp.id} value={emp.id}>
                          {emp.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              {!selectedDate && (
                <div className="d-flex flex-column align-items-center">
                  <img src={reportIMG} height={350} />
                  <h4>Daily Reports are Ready.</h4>
                  <p>Select Date to View Reports.</p>
                </div>
              )}

              {selectedDate && events?.length === 0 && (
                <div className="d-flex flex-column align-items-center">
                  <img src={noreportIMG} height={350} />
                  <h5>No Data Found on This Date or Seleted Location.</h5>
                </div>
              )}

              {selectedDate && events?.length > 0 && (
                <Table responsive bordered>
                  <thead className="bg-blue">
                    <tr>
                      <th>Sr No.</th>
                      <th>Location Name</th>
                      <th>Employee Name</th>
                      <th>Planned Time</th>
                      <th>Actual Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events?.map((event, index) => {
                      // Find the matching timesheet
                      const matchedTimesheet = timeSheets?.find(
                        ts => ts?.calenderSlotId === event?.id
                      )

                      // Determine final status
                      let finalStatus = "Pending"

                      if (matchedTimesheet) {
                        finalStatus = "Completed"
                      } else if (event?.status !== "Available") {
                        finalStatus = event?.status
                      }

                      // Determine row style (red when no timesheet + Available)
                      const rowStyle =
                        !matchedTimesheet && event?.status === "Available"
                          ? { backgroundColor: "#f46a6a", color: "white" }
                          : {}

                      return (
                        <tr key={index} style={rowStyle}>
                          <td>{index + 1}</td>
                          <td>{event?.location?.name}</td>
                          <td>{event?.employee?.name}</td>
                          <td>
                            {formatAnyTime(event?.inTime)} -{" "}
                            {formatAnyTime(event?.outTime)}
                          </td>
                          <td>
                            {formatAnyTime(matchedTimesheet?.inTime)} -{" "}
                            {formatAnyTime(matchedTimesheet?.outTime)}
                          </td>
                          <td>{finalStatus}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        </Container>
      </PermittedComponent>
    </div>
  )
}

export default Reports
